import { Answer } from "@/data/questions";
import { Event } from "@/data/events";
import { MutationTree } from "vuex";
import { State } from "./state";
import { defaultState } from "@/store/state";
import { effectTreeLevel } from "@/game-engine/environment";

export type Mutations<S = State> = {
  nextQuestion(state: S): void;
  submitAnswer(state: S, value: Answer): void;
  handleEvent(state: S, value: Event): void;
  setSubmittedScore(state: S, value: boolean): void;
  setSubmittedComment(state: S, value: boolean): void;
  saveScreenshot(state: S, value: string): void;
  resetState(state: S): void;
  addAnswer(state: S, value: Answer): void;
};

export const mutations: MutationTree<State> & Mutations = {
  submitAnswer(state, value) {
    state.carbonFootprint += value.carbonFootprint;
    state.economicProsperity += value.economicProsperity;
    state.employment += value.employment;
    state.healthHappinessAndWellbeing += value.healthHappinessAndWellbeing;
    state.wildlife += value.wildlife;

    state.carbonFootprintParagraph += `<p class="font-bold">${value.text}</p>`;
    state.carbonFootprintParagraph +=
      value.carbonFootprintCopy + (state.questionId < 5 ? "\n\n" : "");

    state.economicProsperityParagraph += `<p class="font-bold">${value.text}</p>`;
    state.economicProsperityParagraph +=
      value.economicProsperityCopy + (state.questionId < 5 ? "\n\n" : "");

    state.employmentParagraph += `<p class="font-bold">${value.text}</p>`;
    state.employmentParagraph +=
      value.employmentCopy + (state.questionId < 5 ? "\n\n" : "");

    state.healthHappinessAndWellbeingParagraph += `<p class="font-bold">${value.text}</p>`;
    state.healthHappinessAndWellbeingParagraph +=
      value.healthHappinessAndWellbeingCopy +
      (state.questionId < 5 ? "\n\n" : "");

    state.wildlifeParagraph += `<p class="font-bold">${value.text}</p>`;
    state.wildlifeParagraph +=
      value.wildlifeCopy + (state.questionId < 5 ? "\n\n" : "");
  },
  handleEvent(state, value) {
    state.carbonFootprint += value.result.carbonFootprint;
    state.economicProsperity += value.result.economicProsperity;
    state.employment += value.result.employment;
    state.healthHappinessAndWellbeing +=
      value.result.healthHappinessAndWellbeing;
    state.wildlife += value.result.wildlife;

    effectTreeLevel(value.trigger.direction);
  },
  nextQuestion(state) {
    state.questionId += 1;
  },
  setSubmittedScore(state, value) {
    state.submittedScore = value;
  },
  setSubmittedComment(state, value) {
    state.submittedComment = value;
  },
  saveScreenshot(state, value) {
    state.screenshot = value;
  },
  addAnswer(state, value) {
    state.selectedAnswers.push(value);
  },
  resetState(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, defaultState());
  },
};
